export default function userExists(User){
  'ngInject';

  return {
    restrict: "A",
    require: 'ngModel',
    link: ($scope, $element, $attrs, ctrl) =>{
      //Throttle the server request
      if(!ctrl.$options)ctrl.$options = {};
      Object.assign(ctrl.$options, {
        debounce: 500,
        updateOnDefault: true
      });

      //On valid change execute server request
      ctrl.$asyncValidators.exists = function(modelValue) {
        return User.exists( modelValue );
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/userExists/userExists.directive.js
 **/